<template>
  <div class="GlobalFormDemo">
    <el-form :model="formData" inline label-width="80px" size="small" class="el-form-group_isRound" >
      <el-form-item label="机型名称" prop="name">
        <el-input v-model="formData.name" clearable placeholder="请输入机型名称" />
      </el-form-item>
      <el-form-item label="所属分类" prop="machineTypeId">
        <el-select v-model="formData.machineTypeId" clearable placeholder="请选择分类" @change="typeChange">
          <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="所属品牌" prop="brandId">
        <el-select v-model="formData.brandId" filterable clearable placeholder="请选择品牌" @change="brandChange">
          <el-option v-for="item in searchOldBrand" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="所属系列" prop="seriesId">
        <el-select v-model="formData.seriesId" filterable clearable placeholder="请选择系列">
          <el-option v-for="item in seriesSelectList" :key="item.key" :label="item.value" :value="item.key" />
        </el-select>
      </el-form-item>
      <el-form-item label="机型标记" prop="mark">
        <el-select v-model="formData.mark" clearable placeholder="请选择机型标记">
          <el-option v-for="item in markOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否有小型号" prop="hasModelCode" label-width="110px">
        <el-select v-model="formData.hasModelCode" clearable placeholder="请选择">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item label="小型号" prop="modelCode" label-width="70px">
        <el-input v-model="formData.modelCode" clearable placeholder="请输入小型号查询" />
      </el-form-item>
      <el-form-item label="机型来源" prop="channel">
        <el-select v-model="formData.channel" multiple placeholder="请选择机型来源">
          <el-option v-for="item in channelList" :key="item.key" :label="item.value" :value="item.key" />
        </el-select>
      </el-form-item>
      <el-form-item label="询价使用规格" prop="inquirySkuType" label-width="110px">
        <el-select v-model="formData.inquirySkuType" clearable placeholder="请选择使用规格">
          <el-option label="统一规格" value="00" />
          <el-option label="本机规格" value="01" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用" prop="machineName">
        <el-select v-model="formData.isEnable" clearable placeholder="请选择">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" :loading="searchLoading" round @click="handleConfirm">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right">
        <el-button
          icon="el-icon-download"
          size="small"
          type="primary"
          @click="exportExcelDiaShow = true"
          >导出Excel</el-button
        >
        <el-button size="small" type="danger" icon="el-icon-refresh" @click="updateSku">更新规格</el-button>
        <el-button size="small" type="warning" icon="el-icon-refresh" @click="renewModel">更新机型</el-button>
        <el-button size="small" type="warning" icon="el-icon-upload2"
          @click="$refs['importDia'].open()">批量导入机型标记</el-button>
        <!-- <el-button size="small" type="success" icon="el-icon-upload" @click="addModel('import')">批量导入机型</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addModel">添加机型</el-button> -->
      </el-form-item>
    </el-form>
    <!--弹框-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px"
      @closed="handleDialogClosed">
      <el-form ref="form" :model="modelform" label-width="80px" v-if="dialogTitle == '添加机型'">
        <el-form-item label="所属分类">
          <el-select v-model="modelform.machineTypeId" placeholder="请选择分类" @change="addTypeChange">
            <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属品牌">
          <el-select v-model="modelform.brandId" filterable placeholder="请选择品牌" @change="addBrandChange">
            <el-option v-for="ele in addOldBrand" :key="ele.id" :label="ele.name" :value="ele.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属系列">
          <el-select v-model="modelform.seriesId" filterable placeholder="请选择系列">
            <el-option v-for="ele in addSeriesSelectList" :key="ele.key" :label="ele.value" :value="ele.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机型名称">
          <el-input v-model="modelform.name" placeholder="请输入机型名称（限20字以内）"></el-input>
        </el-form-item>
      </el-form>
      <div class="step" v-else>
        <div class="step-title">
          <span>Step1</span>
        </div>
        <div class="step-content">
          <span style="marginRight:12px">表格下载</span>
          <el-link type="primary" @click="download()">点击下载模板表格</el-link>
        </div>
        <div class="step-title">
          <span>Step2</span>
        </div>
        <div class="tip">
          <span class="tip-title">上传表格</span>
          <span class="tip-content">请上传.xls或.xlsx格式的excel文件，大小10M内</span>
        </div>
        <div class="step2-content">
          <el-upload ref="upload" :limit="1" :auto-upload="false" :http-request="uploadFile" :headers="headers"
            :before-upload="onUpload" accept='.xls,.xlsx' action="customize">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="handleBtnLoading" @click.native="handleSuccess">确定</el-button>
        <el-button @click.native="handleClose">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title='更新机型提示' :visible.sync="commandShow" :close-on-click-modal="false" width="500px"
      @closed="commandClosed">
      <div class="enable-tip">
        <div>说明：确定后同时更新手机分类的机型和品牌，一天只能更新一次。</div>
        <div class="tip-sure">是否确认更新机型？</div>
      </div>
      <div class="command">
        <div style="width: 85px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commandClosed">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="renewSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title='更新规格提示' :visible.sync="updateSkuShow" :close-on-click-modal="false" width="500px"
      @closed="command = ''">
      <div class="enable-tip">
        <div>说明：确定后将自动更新该机型的规格信息，一天只更新一次</div>
        <div class="tip-sure">是否确认更新规格？</div>
      </div>
      <div class="command">
        <div style="width: 85px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="updateSkuShow = false">取消</el-button>
        <el-button type="primary" :loading="updateSkuButLoading" @click.native="updateSkuSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title='批量导入机型标记' :visible.sync="importShow" :close-on-click-modal="false" width="700px"
      @closed="command = ''">
      <div class="enable-tip">
        <div>说明：导出待标记机型后，完善表格数据后导入进行标记，单次最多可标记1000条</div>
      </div>
      <el-button type="success" @click="download('tagged')">下载数据模板</el-button>
      <el-button type="danger">导出未标记机型</el-button>
      <div style="display: flex;align-items: center;">
        <span>表格上传</span>
        <div style="margin: 15px;">
          <!-- <el-input placeholder="请输入内容" style="width: 350px" v-model="input1">
          </el-input> -->
          <div style="color: red;margin-top: 5px;">
            仅支持.xls及.xlsx格式,单次上传大小不超过5M
          </div>
        </div>
        <el-upload ref="upload" :limit="1" :auto-upload="false" :http-request="uploadFile" :headers="headers"
          :before-upload="onUpload" accept='.xls,.xlsx' action="customize">
          <el-button type="warning" icon="el-icon-upload2"> 上传表格</el-button>

        </el-upload>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="importShow = false">取消</el-button>
        <el-button type="primary" :loading="updateSkuButLoading" @click.native="updateSkuSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="操作提示"
      :visible.sync="exportExcelDiaShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="command = ''"
    >
      <div class="enable-tip">
        <div class="tip-sure">是否确认导出机型？</div>
      </div>
      <div class="command">
        <div style="width: 85px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="exportExcelDiaShow = false">取消</el-button>
        <el-button type="primary" :loading="exportLoading" @click.native="exportExcel">确定</el-button>
      </span>
    </el-dialog>
    <ImportDia ref="importDia" />
    
  </div>
</template>

<script>
import { formValidateMobile } from '@/utils/form-validate'
import environments from '@/config/url'
import _api from "@/utils/request";
import { encryptByDES } from '@/utils/3DES'
import ImportDia from './dialog/ImportDia.vue';

const uploadUrl = environments[process.env.VUE_APP_BASE_URL].uploadBaseUrl
const fileUrl = environments[process.env.VUE_APP_BASE_URL].fileUrl
export default {
  components: { ImportDia },

  name: 'Form',
  props: {
    classList: Array,
    oldBrand: Array,
    channelList: Array,
  },
  data() {
    return {
      fileUrl,
      uploadUrl,
      headers: {
        'ACCESS_TOKEN': localStorage.getItem('token'),
        'channel': 'platformPc',
        'TOKEN': ''
      },
      modelName: "",
      dialogTitle: "",
      dialogVisible: false,
      handleBtnLoading: false,
      commandShow: false,
      butLoading: false,
      command: "",
      modelform: {
        machineTypeId: '',
        brandId: '',
        seriesId: '',
        name: '',
      },
      file: null,
      formRules: {
        mobile: [{
          validator: formValidateMobile,
          trigger: 'blur'
        }]
      },
      formData: {
        name: "",
        machineTypeId: "",
        brandId: "",
        seriesId: "",
        mark: "",
        hasModelCode: "",
        modelCode: "",
        channel: [],
        inquirySkuType: "",
        isEnable: "",
      },
      searchOldBrand: [], //搜索机型下拉列表
      seriesSelectList: [], //系列下拉列表
      addOldBrand: [],  //添加机型弹框机型下拉列表
      addSeriesSelectList: [], //添加机型弹框系列下拉列表
      // channelOptions: [],
      markOptions: [
        {
          label: "未标记机型",
          value: "10",
        },
        {
          label: "折叠屏机型",
          value: "00",
        },
        {
          label: "曲面屏机型",
          value: "01",
        },
        {
          label: "低端机机型",
          value: "02",
        },
      ],
      searchLoading: false,
      updateSkuShow: false,
      updateSkuButLoading: false,
      importShow: false,
      // 导出弹框
      exportExcelDiaShow: false,
      exportLoading: false,
    }
  },
  created() {
   this.formData.name = this.$route.query.name 
    this.searchOldBrand = this.oldBrand
    this.addOldBrand = this.oldBrand
    // this.getChannelList()
    this.handleConfirm()
    this.getSeriesSelected()
  },
  methods: {
    // getChannelList() {
    //   _api.getMachineChannelList().then(res => {
    //     this.channelOptions = res.data
    //   })
    // },
    //查询
    handleConfirm() {
      console.log(this.formData);
      let _this = this
      this.searchLoading = true
      const SeachParams = {
        ...this.formData,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof _this.stopSearchLoading === 'function') {
            _this.stopSearchLoading()
          }
        },
      }
      this.$nextTick(() => {
        this.$store.commit('tagsView/SEACH_PARAMS', SeachParams)
      })
    },
    handleDialogClosed() {
      this.dialogVisible = false;
      this.modelform = {
        machineTypeId: '',
        brandId: '',
        seriesId: '',
        name: '',
      }
    },
    // 弹窗取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 添加机型
    addModel(val) {
      if (val == 'import') {
        this.dialogTitle = "批量导入机型";
      } else {
        this.getAddSeriesSelected()
        this.dialogTitle = "添加机型";
      }

      this.dialogVisible = true;
    },
    handleSuccess() {
      if (this.dialogTitle == '添加机型') {
        this.handleBtnLoading = true
        console.log(this.modelform,'this.modelformthis.modelform');
        
        _api.modelAdd(this.modelform).then(res => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            //  const SeachParams = {
            //    pageNum: 1,
            //    pageSize: 10,
            //  }
            //  this.$store.commit('tagsView/SEACH_PARAMS',SeachParams)
            this.handleConfirm()
          } else {
            this.$message.error("操作失败");
          }
        }).finally(()=>{
          this.handleBtnLoading = false
        })
      } else {
        this.$refs.upload.submit();
      }
    },
    uploadFile(params) {
      console.log("uploadFile", params);
      const _file = params.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      this.handleBtnLoading = true
      // 发起请求
      _api.importAdd(formData).then(res => {
        console.log("_RequestUploads_", res);
        if (res.code === 1) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.dialogVisible = false;
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      }).finally(res => {
        this.handleBtnLoading = false
      })
    },
    // 筛选条件
    download(type) {
      const link = document.createElement('a')
      link.href = type == 'tagged' ? "/static/导入标记机型数据模板.xlsx" : "/static/导入机型模板.xlsx"
      link.setAttribute('download', type == 'tagged' ? "导入标记机型数据模板.xlsx" : "导入机型模板.xlsx")
      document.body.appendChild(link)
      link.click()
    },
    onUpload(e) {
      this.headers.TOKEN = encryptByDES(encryptByDES((new Date().getTime()).toString(), '63e42c2444e94c1ebca21d30d2aa39a5'), localStorage.getItem('token') || '')
    },
    renewModel() {
      this.commandShow = true
    },
    commandClosed() {
      this.command = ""
      this.commandShow = false
    },
    renewSubmit() {
      if (!this.command.trim()) {
        return this.$message.error('请输入动态口令')
      }
      this.butLoading = true
      _api.modelRefresh({ command: this.command }).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg || '更新成功')
          this.commandShow = false
          console.log(res);
        }
        this.butLoading = false
      }).catch(err => {
        this.butLoading = false
      })
    },
    stopSearchLoading() {
      this.searchLoading = false
    },
    updateSku() {
      this.updateSkuShow = true
    },
    updateSkuSubmit() {
      if (!this.command.trim()) {
        return this.$message.error('请输入动态口令')
      }
      this.updateSkuButLoading = true
      _api.refreshSku({ command: this.command }).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg || '更新成功')
          this.updateSkuShow = false
        }
        this.updateSkuButLoading = false
      }).catch(err => {
        this.updateSkuButLoading = false
      })
    },
    importModel() {
      this.importShow = true
    },
    //导出Excel
    exportExcel() {
      if (!this.command.trim()) {
        return this.$message.error('请输入动态口令')
      }
      this.exportLoading = true;
      _api
      .modeListExcel({...this.formData,command: this.command})
      .then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || '服务繁忙');
            }
          } catch (err) {
            const fileName = "机型管理列表.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
            this.exportExcelDiaShow = false
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    typeChange() {
      this.formData.seriesId = ""
      this.formData.brandId = ""
      this.searchOldBrand = []
      this.seriesSelectList = []
      this.getSeriesSelected()
      this.getResidentList()
    },
    brandChange() {
      this.formData.seriesId = ""
      this.seriesSelectList = []
      this.getSeriesSelected()
    },
    // 搜索获取旧机品牌列表
    getResidentList() {
      _api.ResidentList({typeId:this.formData.machineTypeId}).then(res => {
        this.searchOldBrand = res.data
      })
    },
    // 搜索获取系列下拉列表
    getSeriesSelected() {
      let params = {
        typeId: this.formData.machineTypeId,
        brandId: this.formData.brandId,
      }
      _api.getSeriesSelected(params).then(res => {
        this.seriesSelectList = res.data
      })
    },
    
    addTypeChange() {
      this.modelform.seriesId = ""
      this.modelform.brandId = ""
      this.addOldBrand = []
      this.addSeriesSelectList = []
      this.getAddSeriesSelected()
      this.getAddResidentList()
    },
    addBrandChange() {
      this.modelform.seriesId = ""
      this.addSeriesSelectList = []
      this.getAddSeriesSelected()
    },
    // 搜索获取旧机品牌列表
    getAddResidentList() {
      _api.ResidentList({typeId:this.modelform.machineTypeId}).then(res => {
        this.addOldBrand = res.data
      })
    },
    // 搜索获取系列下拉列表
    getAddSeriesSelected() {
      let params = {
        typeId: this.modelform.machineTypeId,
        brandId: this.modelform.brandId,
        isFilterDelete: true, //是否过滤删除
      }
      _api.getSeriesSelected(params).then(res => {
        this.addSeriesSelectList = res.data
      })
    },
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .import-img {
    vertical-align: middle;
  }

  .step {
    .step-title {
      color: #0981FF;
      margin-bottom: 10px;
      padding-left: 6px;
      border-left: 3px solid;
      border-radius: 1.5px;
    }

    .step-content,
    .step2-content {
      margin-bottom: 26px;
    }

    .step2-content>div {
      display: flex;
    }

    .step2-content {
      .upload-demo {
        display: flex;
        justify-content: start;

        .el-upload-list {
          width: 200px;
        }
      }

    }

    .tip {
      margin-bottom: 12px;

      .tip-title {
        color: #666666;
        margin-right: 12px;
      }

      .tip-content {
        color: #FF687B;
        font-size: 12px;
      }
    }

  }

  .file-input {
    width: 340px;
    height: 34px;
    line-height: 34px;
    display: block;
    border: 1px solid #ccc;
    padding: 0 5px;
  }

  .enable-tip {
    color: #FF8080;
    font-size: 14px;
    margin-bottom: 20px;

    .tip-sure {
      margin-top: 10px;
      color: #333333;
      font-size: 16px;
      text-align: center;
    }
  }

  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}
</style>
